import styled from 'styled-components';

export const StyledProfilePage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
  }

  .header {
    color: #000;
  }

  .page-content {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;

    @media (max-width: 959px) {
      flex-direction: column;
      align-items: center;
    }
  }

  .purchases_cards {
    display: flex;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 32px;
    width: 100%;

    @media (max-width: 767px) {
      justify-content: center;
    }

    & > .purchase_card {
      width: 100%;
      max-width: 352px;
    }

    .no_transactions {
      background-color: #f6d9d8;
      max-width: unset;
      align-self: flex-start;
      padding: 32px;
      border-radius: 4px;

      p {
        font-size: 20px;
        line-height: 31px;
        font-weight: 700;
        color: #111;
      }
    }
  }

  .dialog_title {
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    margin: 0;
  }

  .dialog_description {
    font-size: 15px;
    font-weight: 400;
    line-height: 23px;
    margin: 0;
  }

  .dialog_list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-size: 15px;
    font-weight: 400;
    line-height: 23px;
    margin: 0;
    padding-left: 22px;
  }

  .filled_button {
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    color: #fff;
    text-decoration: none;
    background-color: #164144;
    padding: 12px 24px;
    border-radius: 50px;
    cursor: pointer;

    &:hover {
      background-color: #193639;
    }
    &:active {
      box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
        0px 8px 10px 1px rgba(0, 0, 0, 0.14),
        0px 3px 14px 2px rgba(0, 0, 0, 0.12);
    }
  }

  .outlined_button {
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    color: #13142a;
    background-color: #fff;
    text-decoration: none;
    padding: 12px 24px;
    border: 1.5px solid #d1ede8;
    border-radius: 50px;
    cursor: pointer;

    &:hover {
      background-color: #f8f8f8;
    }
    &:active {
      box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
        0px 8px 10px 1px rgba(0, 0, 0, 0.14),
        0px 3px 14px 2px rgba(0, 0, 0, 0.12);
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    row-gap: 32px;
    width: 100%;
    max-width: 736px;

    @media (max-width: 959px) {
      align-items: center;
    }
  }

  .purchases_cards {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 32px;
    width: 100%;

    @media (max-width: 767px) {
      justify-content: center;
    }

    & > .purchase_card {
      width: 100%;
      max-width: 352px;
    }

    .no_transactions {
      background-color: #f6d9d8;
      max-width: unset;
      align-self: flex-start;
      padding: 32px;
      border-radius: 4px;

      p {
        font-size: 20px;
        line-height: 31px;
        font-weight: 700;
        color: #111;
      }
    }
  }

  .filled_button {
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    color: #fff;
    text-decoration: none;
    background-color: #164144;
    padding: 12px 24px;
    border-radius: 50px;
    cursor: pointer;

    &:hover {
      background-color: #193639;
    }
    &:active {
      box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
        0px 8px 10px 1px rgba(0, 0, 0, 0.14),
        0px 3px 14px 2px rgba(0, 0, 0, 0.12);
    }
  }

  .help_aside {
    position: sticky;
    top: 120px;
    width: 100%;
    max-width: 352px;

    @media (max-width: 959px) {
      margin-top: 32px;
    }
  }

  .help_box {
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    gap: 24px;
    background-color: #fff;
    padding: 32px;

    h3 {
      font-size: 20px;
      line-height: 31px;
      font-weight: 700;
      margin: 0;
      color: #111;
    }

    p {
      font-size: 16px;
      line-height: 25px;
      font-weight: 500;
      margin: 0;
      color: #111;
    }

    .filled_button {
      text-align: center;
    }
  }

  .link_list a {
    font-size: 14px;
    line-height: 19px;
    font-weight: 500;
    color: #000;
  }
`;

export const StyledProfileCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: ${(props) => !props.$fullWidth && '352px'};
  width: 100%;
  padding: 24px 16px;
  row-gap: ${(props) => (props.$fullWidth ? '24px' : '16px')};
  border-radius: 8px;
  background: #fff;

  form {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    width: 100%;

    label {
      font-weight: 700;
    }

    .input-wrapper {
      margin: 0;
    }

    .actionBtn > div {
      margin: 0;
    }

    &.delete-form {
      row-gap: 24px;
    }

    .delete-form-actionBtn > div {
      justify-content: flex-start;
      margin: 0;
    }
  }

  .checkboxLabel {
    display: flex;
    font-weight: 500;
    color: #13142a;

    @media (max-width: 959px) {
      .labelTextClassName {
        font-size: 14px !important;
        line-height: 16px;
      }
    }
  }

  .submit-button {
    font-size: 14px;
    line-height: 16px;
    padding: 12px 24px;
  }

  .data-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e6e6e6;
    width: 100%;
  }

  .accordionRoot {
    box-shadow: unset;
    margin: 0;
    border-top: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;

    &:before {
      display: none;
    }

    &.Mui-expanded {
      border-bottom: unset;
    }
  }

  .accordionSummary {
    padding: 0;

    &.Mui-expanded {
      min-height: unset;
    }
  }

  .accordionContent {
    display: flex;
    align-items: center;
    column-gap: 8px;
    font-size: 14px;
    color: #000;

    &.Mui-expanded {
      margin: 12px 0;
    }
  }

  .accordionDetails {
    display: flex;
    flex-direction: column;
    padding: 0;
    row-gap: 10px;
    font-size: 12px;
    line-height: 19px;
    color: #717171;

    p {
      margin: 0;
    }

    ul {
      padding-left: 20px;
    }

    .alert-message {
      display: flex;
      align-items: center;
      column-gap: 12px;
      font-size: 12px;
      line-height: 19px;
      color: #111;
      background: #f6d9d8;
      border-radius: 4px;
      margin-top: 6px;
      padding: 12px 16px;
    }
  }
`;

export const StyledTermsBlock = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;

  h2 {
    font-size: 18px;
    line-height: 19px;
    color: #000;
    margin: 0;
  }

  a {
    font-size: 14px;
    line-height: 19px;
    color: #000;
    text-decoration: underline;
  }
`;

export const StyledHeadline = styled.h2`
  font-size: 18px;
  line-height: 19px;
  color: #000000;
  padding: 0;
  margin: 0;
`;

export const StyledText = styled.p`
  font-size: 14px;
  line-height: 19px;
  color: #717171;
  padding: 0;
  margin: 0;
`;
